/* eslint-disable quotes */
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import OcurrenceRepository from '@/shared/http/repositories/realestate/ocurrence'
import InputsOccurrenceRepository from '@/shared/http/repositories/realestate/inputsoccurrence'
import Chart from 'chart.js'
import { loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import VueHtml2pdf from 'vue-html2pdf'
import ChartPlugin from 'chartjs-plugin-labels'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
import cabecalhoPng from '../../../../../../../static/img/realestate/relatorio/cabecalho_vertical.png'
import ChartDataLabels from 'chartjs-plugin-datalabels'
// import CharDataOutLabels from 'chartjs-plugin-piechart-outlabels'
import html2canvas from 'html2canvas'
// import { Pie } from 'vue-chartjs'
// import { loading } from '@/shared/utils/UIHelper'
// import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

// ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

var stringToColour = function (str) {
  var hash = 0
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  var colour = '#'
  for (var j = 0; j < 3; j++) {
    var value = (hash >> (j * 8)) & 0xFF
    colour += ('00' + value.toString(16)).substr(-2)
  }
  return colour
}

export default {
  name: 'ChartTotalCost',
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    VueHtml2pdf,
    // Pie,
    ChartPlugin
  },
  props: {
    formSearch: {
      Type: Object,
      default: null
    }
  },
  watch: {
    'formSearch': function () {
      this.GetTotalCusto()
    }
  },
  data () {
    return {
      empreedimentoArray: [],
      dataFormatada: null,
      patologiaPdfArray: [],
      Totalocorrencias: null,
      img1: cabecalhoPng,
      ocorrencias: [],
      periodoFiltro: null,
      StatusFiltro: null,
      imagem: null,
      semDados: false,
      somaTotal: 0,
      patologias: [],
      chartData: {
        labels: [ 'January', 'February', 'March' ],
        datasets: [ { data: [40, 20, 12] } ]
      },
      chartInfo: false,
      series: [44, 55, 13, 43, 22],
      chartOptions: {
        chart: {
          width: 380,
          type: 'pie'
        },
        labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
      TotalInsumos: 0,
      dataRelatorio: null,
      dataInicio: null,
      dataFim: null,
      total: 0,
      valorOcorrencias: '',
      somaValor: 0,
      somaChamados: 0
    }
  },
  mounted () {
    var custoTotal = localStoreHelper.controleOcorrencia.custoTotal()
    if (custoTotal.dataFinal !== null || custoTotal.dataFinal !== '') {
      this.dataFim = custoTotal.dataFinal
    }
    if (custoTotal.dataInicio !== null || custoTotal.dataInicio !== '') {
      this.dataInicio = custoTotal.dataInicio
    }
    // if (custoTotal !== null && custoTotal !== undefined && custoTotal.value !== null) {
    //   this.GetTotalCusto()
    // }
    // this.GetPatologias()
    // this.GetTotalCusto()
    this.dataFormatadaPdf()
    console.log(this.img1)
    console.log(this.img2)
  },
  methods: {
    verificaTamanhoEmpreendimento (value) {
      if (value.length > 20) {
        return value.substring(0, 20) + "..."
      }
      return value
    },
    dataFormatadaPdf () {
      var dataAtual = new Date()
      var ano = dataAtual.getFullYear()
      var mes = ('0' + (dataAtual.getMonth() + 1)).slice(-2)
      var dia = ('0' + dataAtual.getDate()).slice(-2)
      this.dataFormatada = dia + '/' + mes + '/' + ano
    },
    createImageHeaderFooter (imgHref) {
      const img = document.createElement("img")
      img.src = imgHref
      img.style.border = "none"
      return img
    },
    async abrirNovaGuia ({ html2pdf, options, pdfContent }) {
      const headerImage = new URL(cabecalhoPng)
      const headerPdf = this.createImageHeaderFooter(headerImage.href)

      options.margin = [1.5, 0, 0.5, 0]
      html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages()
        for (let i = 1; i <= totalPages; i++) {
          pdf.addImage(headerPdf, 'Image-HTMLElement ', 0, 0, 0, 1.3)
          pdf.setPage(i)
          pdf.setFillColor(28, 98, 40)
          pdf.rect(0, pdf.internal.pageSize.getHeight() - 0.4, pdf.internal.pageSize.getWidth(), 10, 'F')
          pdf.setTextColor('#fff')
          pdf.setFont('Helvetica', 'normal') // Set font to normal for the next part
          pdf.setFontSize(10)
          pdf.text('Zopone OCE - ', 0.3, pdf.internal.pageSize.getHeight() - 0.15)
          pdf.setFont('Helvetica', 'bold') // Set font back to bold
          pdf.text(
            ' Relatório de custos ' + this.dataRelatorio,
            1.35,
            pdf.internal.pageSize.getHeight() - 0.15
          )
          pdf.setFont('Helvetica', 'normal') // Set font to normal for the next part
          pdf.text(
            'Pág ',
            7,
            pdf.internal.pageSize.getHeight() - 0.15
          )
          pdf.setFont('Helvetica', 'bold')
          pdf.text(
            i + ' de ' + totalPages,
            7.3,
            pdf.internal.pageSize.getHeight() - 0.15
          )
        }
      }).save()
    },
    generatePDF () {
      this.$refs.html2Pdf.generatePdf()
    },
    async captureCanvasScreenshot () {
      // Crie um elemento <canvas> temporário para desenhar a imagem
      const canvasElement = document.getElementById('myChart')
      const legendCanvas = await html2canvas(document.querySelector('#legends'))
      // const infoCanvas = await html2canvas(document.querySelector('#info-grafico'))
      const tempCanvas = document.createElement('canvas')
      const tempContext = tempCanvas.getContext('2d')
      tempCanvas.width = canvasElement.width
      tempCanvas.height = canvasElement.height + legendCanvas.height
      tempContext.drawImage(canvasElement, 0, 0)
      tempContext.drawImage(legendCanvas, 0, canvasElement.height)
      // tempContext.drawImage(infoCanvas, canvasElement.width - 200, canvasElement.height - 150)
      const screenshot = new Image()
      screenshot.src = tempCanvas.toDataURL('image/png')
      this.imagem = screenshot
    },

    closeModal () {
      this.$refs['popup-pdf-modal'].hide()
      this.imagem = null
    },
    openpopPdf () {
      this.$refs['popup-pdf-modal'].show()
      this.captureCanvasScreenshot()
      this.GetPatologiaPdfs()
    },
    async chart () {
      // var soma = this.somaTotal
      const chart = document.getElementById('myChart')
      const legends = document.getElementById('legends')
      if (chart.length !== 0) {
        chart.remove()
        const container = document.querySelector('.chart-container')

        const newChart = document.createElement('canvas')
        newChart.style.background = '#f4f4f4'
        newChart.style.borderRadius = '25px'
        newChart.style.marginBottom = '1rem'
        newChart.id = 'myChart'
        container.append(newChart)

        // eslint-disable-next-line no-new
        const myChart = new Chart(newChart, {
          plugins: [ChartDataLabels],
          type: 'pie',
          data: {
            labels: this.patologias.map(x => x.nome + " - " + x.quantidadeTotalFormatada),
            datasets: [{
              nome: this.patologias.map(x => x.nome),
              data: this.patologias.map(x => x.Total),
              dataInicio: this.patologias[0].dataInicio,
              dataFim: this.patologias[0].dataFim,
              quantidadeTotalFormatada: this.patologias.map(x => x.quantidadeTotalFormatada),
              backgroundColor: this.patologias.map(x => stringToColour(x.nome)),
              insumosTotal: this.patologias.map(x => x.totalOcorrencias),
              soma: this.formatMoney(this.somaTotal),
              porcentagem: this.patologias.map(x => x.quantidadeTotal / this.somaTotal),
              hoverOffset: 4,
              datalabels: {
                anchor: 'end',
                borderColor: '#f4f4f4',
                backgroundColor: this.patologias.map(x => stringToColour(x.nome)),
                borderRadius: 25,
                borderWidth: 0,
                fontFamily: 'Poppins',
                fontSize: 8,
                fontColor: '#fff',
                color: 'white',
                padding: 100,
                formatter: function (value, context) {
                  var porcentagemIndex = context.dataset.porcentagem[context.dataIndex]
                  if (porcentagemIndex < 0.05) {
                    return context.dataset.nome[context.dataIndex] +
                    '\n' + ((value / context.dataset.teste) * 100).toFixed(2) + '% - ' +
                    this.formatMoney(Math.floor(value))
                  } else {
                    return context.dataset.nome[context.dataIndex] + ' \n ' +
                    this.formatMoney(Math.floor(value))
                  }
                }
                // labels: {
                //   index: {
                //     display: true,
                //     align: 'end',
                //     clamp: true,
                //     anchor: 'end',
                //     offset: function (context) {
                //       var index = context.dataIndex
                //       if (context.dataset.nome.length > 5) {
                //         var pad = 5
                //         for (var x = 0; x <= index; x++) {
                //           pad += 50
                //           if (pad >= 150) {
                //             pad = 5
                //           }
                //         }
                //       } else {
                //         pad = 20
                //       }
                //       return pad
                //     },
                //     textAlign: 'center'
                //   }
                // }
              }
            }]
          },
          options: {
            title: {
              display: true,
              text: `Período: (${this.patologias[0].dataInicio} - ${this.patologias[0].dataFim})`,
              padding: 10,
              fontFamily: 'Poppins',
              fontSize: 18
            },
            layout: {
              padding: 25
            },
            scales: {
              y: {
                beginAtZero: true
              }
            },

            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  return data.labels[tooltipItem.index]
                }
              }
            },
            plugins: {
              // outlabels: {
              //   display: true,
              //   borderRadius: 0,
              //   borderWidth: 0,
              //   stretch: function (context) {
              //     var index = context.dataIndex
              //     if (context.dataset.nome.length > 5) {
              //       var pad = 15
              //       for (var x = 0; x <= index; x++) {
              //         pad += 50
              //         if (pad >= 150) {
              //           pad = 15
              //         }
              //       }
              //     } else {
              //       pad = 20
              //     }
              //     return pad
              //   },
              //   font: {
              //     resizable: false,
              //     size: 0
              //   }
              // },
              datalabels: {
                display: false
              },
              labels: [
                {

                  render: function (args) {
                    if (args.percentage > 5) {
                      return args.percentage + '%'
                    }
                  },
                  fontColor: '#fff',
                  overlap: true,
                  fontFamily: 'Poppins',
                  fontSize: 16,
                  precision: 2
                }
              ]
            },
            legend: false,
            legendCallback: function (chart) {
              var soma = chart.data.datasets[0].soma
              var sum = chart.data.datasets[0].insumosTotal.reduce(function (accumulator, currentValue) {
                return accumulator + currentValue
              }, 0)
              var container = document.createElement('div')
              container.setAttribute('class', 'container-legend')
              container.style.display = 'flex'
              container.style.position = 'relative'
              var info = document.createElement('div')
              info.setAttribute('id', 'info-grafico')

              // info.style.position = 'end'
              // info.style.top = '15%'
              // info.style.transform = 'translateY(-80%) translateX(-430%)'
              // info.style.left = '5%'
              info.style.fontFamily = 'Poppins'
              info.style.display = 'flex'
              info.style.flexDirection = 'column'
              info.style.alignItems = 'flex-end'
              info.style.position = 'absolute'
              info.style.bottom = '0'
              info.style.right = '0'
              info.style.order = '0'
              info.style.margin = '1rem'
              info.innerHTML += `
              <div style='display:flex; font-size: 19px; gap: 1vw; flex-direction: column; width: 180px'>
                <div style='display: flex; gap: 0.5rem; flex-direction: column; align-items: flex-end;'>
                  <div style='color:#008148;'><strong>${sum}</strong></div>
                  <div >N° Chamados</div>
                </div>
                <div style='display: flex; flex-direction: column; align-items: flex-end;'>
                  <div style='color:#008148'><strong>${soma}</strong></div>
                  <div>Valor Total</div>
                </div>
              </div>
              `
              var div = document.createElement('div')
              div.setAttribute('id', 'legenda-grafico')
              div.style.display = 'flex'
              div.style.flexWrap = 'wrap'
              div.style.justifyContent = 'flex-start'
              div.style.fontFamily = 'Poppins'
              div.style.fontSize = '20px'
              div.style.padding = '0.5rem, 1rem'
              var resultado = "<strong style='display: flex; font-size:22px ;font-family: Poppins; padding: 1rem'>Resultados:</strong>"
              var legend = document.createElement('div')
              legend.setAttribute('class', 'group-grafico')
              legend.style.display = 'flex'
              legend.style.flexDirection = 'column'
              legend.style.width = '80%'
              legend.innerHTML += resultado
              legend.append(div)
              container.append(legend)
              container.append(info)
              chart.data.labels.forEach(function (label, index) {
                var backgroundColor = chart.data.datasets[0].backgroundColor[index]
                var quantidadeTotal = chart.data.datasets[0].quantidadeTotalFormatada[index]
                var insumosTotal = chart.data.datasets[0].insumosTotal[index]
                var porcento = (chart.data.datasets[0].porcentagem[index] * 100).toFixed(2)
                var nome = label
                var a = nome.indexOf("- R$")
                var extractedString = nome.substring(0, a).trim()
                div.innerHTML += `
                <div style="display: flex; width:calc(50% - 1rem); padding: 1rem">
                  <div style="display: flex; flex-direction: column; padding: 0.5rem; gap: 0.5rem; width:100%">
                    <div style="display: flex;">
                      <div style="width: 20px; height: 20px; background-color:${backgroundColor}; cursor: pointer; margin-right: 1rem">
                      </div>
                      <span style=" cursor: pointer;">
                        <strong>${extractedString}</strong>
                      </span>
                    </div>
                    <div>
                      <div>N° Chamados -  <strong>${insumosTotal}</strong><strong></strong></div>
                    </div>
                    <div>
                      <div style="line-height: 2rem">Valor Total - <strong>${quantidadeTotal}</strong> - <strong>${porcento}%</strong></div>
                    </div>
                  </div>
                </div>
                `
              })
              return container.outerHTML
            }
          }
        })
        legends.innerHTML = myChart.generateLegend()
      }
      if (chart.lenght !== 0) {
        chart.remove()
      }
    },
    GetPatologias () {
      OcurrenceRepository.GetPatologia()
        .then((Response) => {
          this.patologias = Response
        })
        .catch((Error) => {

        })
    },
    GetPatologiaPdfs () {
      let parametros = localStoreHelper.controleOcorrencia.custoTotal() || this.formSearch
      this.periodoFiltro = parametros.periodoEnum
      this.StatusFiltro = parametros.statusOcorrencia
      // this.dataInicio = parametros.dataInicio
      // this.dataFim = parametros.dataFinal
      this.verificaPeriodo()
      this.verificaStatus()
      this.GetEmpreendimentoPdf()
      this.GetCustosPatologiasPdf()
      loading.push()
      InputsOccurrenceRepository.GetCustosPdf(parametros)
        .then((Response) => {
          this.total = 0
          this.ocorrencias = Response.data
          loading.pop()
          this.ocorrencias.forEach(obj => {
            this.total += obj.custoTotalByEmpreendimento.length
          })
          this.TotalInsumos = this.ocorrencias[0].totalInsumoEmpreendimentos
          this.dataInicio = this.ocorrencias[0].dataInicio
          this.dataFim = this.ocorrencias[0].dataFim
        })
        .catch((Error) => {
          loading.pop()
          console.log(Error)
        })
    },
    GetCustosPatologiasPdf () {
      let parametros = localStoreHelper.controleOcorrencia.custoTotal() || this.formSearch
      loading.push()
      InputsOccurrenceRepository.GetCustosPatologiasPdf(parametros)
        .then((Response) => {
          loading.pop()
          this.patologiaPdfArray = Response.data
          let diaAtual = new Date()
          let dia = diaAtual.getDate()
          if (dia < 10) {
            dia = '0' + dia
          }
          let mes = diaAtual.getMonth() + 1
          if (mes < 10) {
            mes = '0' + mes
          }
          let ano = diaAtual.getFullYear()
          this.dataRelatorio = dia + '/' + mes + '/' + ano
        })
        .catch((Error) => {
          loading.pop()
          console.log(Error)
        })
    },

    GetEmpreendimentoPdf () {
      let parametros = localStoreHelper.controleOcorrencia.custoTotal() || this.formSearch
      loading.push()
      OcurrenceRepository.GetEmpreendimentoPdf({EmpreendimentoId: parametros.enterprise})
        .then((Response) => {
          loading.pop()
          this.empreedimentoArray = Response.data
          this.TotalEmpreendimento = this.empreedimentoArray.length
        })
        .catch((Error) => {
          loading.pop()
          console.log(Error)
        })
    },
    verificaPeriodo () {
      if (this.periodoFiltro === 0) {
        this.periodoFiltro = 'MENSAL'
      } else if (this.periodoFiltro === 1) {
        this.periodoFiltro = 'SEMANAL'
      } else if (this.periodoFiltro === 2) {
        this.periodoFiltro = 'ANUAL'
      } else {
        this.periodoFiltro = 'PERSONALIZADO'
      }
    },
    verificaStatus () {
      if (this.StatusFiltro === '3') {
        this.StatusFiltro = 'CONCLUÍDO'
      } else if (this.StatusFiltro === '-1') {
        this.StatusFiltro = 'CANCELADO'
      } else if (this.StatusFiltro === '1') {
        this.StatusFiltro = 'AG. VISTORIA TÉCNICA'
      } else if (this.StatusFiltro === '2') {
        this.StatusFiltro = 'EM ANDAMENTO'
      } else {
        this.StatusFiltro = 'N/D'
      }
    },
    GetTotalCusto () {
      this.somaTotal = 0
      let parametros = this.formSearch
      this.semDados = true
      loading.push()
      this.patologias = []
      InputsOccurrenceRepository.GetTotalCusto(parametros)
        .then((Response) => {
          loading.pop()
          if (Response.data.length > 0) {
            Response.data.forEach((Element) => {
              let data = Element
              data['Total'] = 0
              data['Total'] = Element.quantidadeTotal
              this.patologias.push(data)
              // this.patologias.find((x) => {
              //   if (x.Total !== 0) {
              //     this.semDados = false
              //   }
              // })
            })
          }
          let teste = this.patologias.map(Element => Element.Total)
          for (let i = 0; i < teste.length; i++) {
            this.somaTotal += teste[i]
          }
          if (this.somaTotal > 0) {
            this.chart()
          } else {
            this.semDados = false
          }
          let somaTotal = this.patologias.map(x => x.totalOcorrencias)
          this.somaTotal = somaTotal.reduce((a, c) => a + c, 0)
          let somaValor = this.patologias.map(x => x.quantidadeTotal)
          this.somaValor = somaValor.reduce((a, c) => a + c, 0)
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
        // .finally(() => {
        //   this.formSearch = {}
        // })
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    formatLength (value) {
      if (value < 10) {
        return '0' + value
      } else {
        return value
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/totalCost/components/chartTotalCost/chartTotalCost.js